import { render, staticRenderFns } from "./VariantEditor.vue?vue&type=template&id=871f1646"
import script from "./VariantEditor.vue?vue&type=script&lang=js"
export * from "./VariantEditor.vue?vue&type=script&lang=js"
import style0 from "./VariantEditor.vue?vue&type=style&index=0&id=871f1646&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports